import { memo, useContext, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { sendApiRequest } from "../services/Base/base-service";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Alert,
  Icon,
  Spinner,
} from "design-react-kit";

import FilesViewModal from "./Modals/FilesViewModal";
import FlowTypeEnum from "../helpers/Enums/FlowTypeEnum";
import UserContext from "../store/user-context";

const NotificationAccordionItem = ({ notification, lastBookElementRef }) => {
  const [dataCollapseOpen, setDataCollapseOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [recipientId, setRecipientId] = useState(null);
  const [description, setDescription] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationRecipients, setnotificationRecipients] = useState([]);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const collapseHandler = (e) => {
    if (
      !e.target.classList.contains("icon") &&
      e.target.tagName.toLowerCase() !== "path"
    ) {
      if (!dataCollapseOpen) {
        getStagedFlowNotificationRecipients();
      } else {
        setnotificationRecipients(null);
      }
      setDataCollapseOpen((prevState) => !prevState);
    }
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
    setRecipientId(null);
  };

  const setModalOpenHandler = () => {
    setModalOpen(true);
  };

  const setModalOpenHandlerForPaymentFiles = (recipientId, description) => {
    setRecipientId(recipientId);
    setDescription(description);
    setModalOpen(true);
  };

  const getStagedFlowNotificationRecipients = () => {
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      `StagedFlowNotification/GetStagedFlowNotificationRecipients?stagedFlowNotificationId=${notification.id}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setError(null);
          setnotificationRecipients(
            response.data.stagedFlowNotificationRecipients,
          );
          setIsLoading(false);
        }
      }
    });
  };

  return (
    <div className="w-100 p-0" key={notification.id} ref={lastBookElementRef}>
      <Accordion iconLeft className="border-bottom-0 w-100 p-0 m-0">
        <AccordionHeader
          className="f24notifiationAccordion w-100 pt-0"
          active={dataCollapseOpen}
          onToggle={(e) => collapseHandler(e)}
        >
          <div className="w-100 d-flex align-items-start justify-content-between p-0 mt-3 mb-3">
            <span className="createdOn text-center text-nowrap col-2">
              {notification.createdOn}
            </span>
            <span className="subject col-4">{notification.subject}</span>
            <span className="amount text-center col-1">
              {(notification.amount / 100).toFixed(2)}€
            </span>
            <span className="text-right col-1 mr-4" title="Visualizza allegati">
              <Icon
                icon="it-password-visible"
                fill="#06c"
                role="button"
                onClick={(e) => {
                  setModalOpenHandler(notification.id, notification.subject);
                }}
              />
            </span>
          </div>
        </AccordionHeader>
        <AccordionBody className="w-90 mx-auto" active={dataCollapseOpen}>
          <hr className="w-100" />
          <div className="w-100 d-flex align-items-center justify-content-between font-weight-bold">
            <span className="createdOn text-nowrap col-4">
              Codice fiscale destinatario
            </span>
            <span className="subject col-4">
              Numero avviso pagoPA / Titolo documento (F24)
            </span>
            <span className="text-center edit-invalid-notification col-1"></span>
          </div>
          <hr className="mb-0 w-100" />
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {isLoading && (
            <p
              style={{
                height: "50px",
                position: "relative",
                marginBottom: "3rem",
              }}
            >
              <Spinner double active />
            </p>
          )}
          {notificationRecipients !== null &&
            notificationRecipients.map((notificationRecipient) => (
              <div
                tabindex="0"
                className="recipientRow"
                key={notificationRecipient.id}
              >
                <div className="w-100 d-flex align-items-start justify-content-between p-0 pt-3 mb-3">
                  <span className="recipientFiscalCode  text-nowrap col-4">
                    {notificationRecipient.recipientFiscalCode}
                  </span>
                  <span className="paymentNoticeCode col-4">
                    {notificationRecipient.description}
                  </span>
                  <span
                    className="text-right col-1 mr-4"
                    title="Visualizza documenti di pagamento"
                  >
                    <Icon
                      icon="it-password-visible"
                      fill="#06c"
                      role="button"
                      onClick={(e) => {
                        setModalOpenHandlerForPaymentFiles(
                          notificationRecipient.id,
                          notificationRecipient.description,
                        );
                      }}
                    />
                  </span>
                </div>
                <hr className="w-100" />
              </div>
            ))}
        </AccordionBody>
      </Accordion>
      <FilesViewModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        notificationId={notification.id}
        notificationSubject={notification.subject}
        flowType={FlowTypeEnum.Json_v2}
        recipientId={recipientId}
        description={description}
      />
    </div>
  );
};

export default memo(NotificationAccordionItem);
